/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { User } from "./User";
export const UserResponse = core.serialization.object({
    data: User,
});
